import React, { useEffect, useRef, useState } from "react";
import { Play, Square } from "lucide-react";

const KIT = "/media/samples/kit";
const SND = { hh: `${KIT}/hhc_vl2_rr1.mp3`, sn: `${KIT}/snare_vl4_rr1.mp3`, bd: `${KIT}/kick_vl3_rr1.mp3` };
// One bar of eighths: hi-hat every eighth, kick on 1 and 3, snare on 2 and 4.
const BAR = [["hh", "bd"], ["hh"], ["hh", "sn"], ["hh"], ["hh", "bd"], ["hh"], ["hh", "sn"], ["hh"]];
const COUNT = ["1", "&", "2", "&", "3", "&", "4", "&"];

// Plays the basic rock beat shown on the drum stave above, highlighting each count.
export const DrumBeatPlayer = () => {
  const [step, setStep] = useState(-1);
  const timer = useRef(null);
  const ctx = useRef(null);
  const bufs = useRef(null);

  const load = async () => {
    ctx.current = ctx.current || new (window.AudioContext || window.webkitAudioContext)();
    if (!bufs.current) {
      const entries = await Promise.all(Object.entries(SND).map(async ([k, u]) => [k, await ctx.current.decodeAudioData(await (await fetch(u)).arrayBuffer())]));
      bufs.current = Object.fromEntries(entries);
    }
  };
  const hit = (k) => { const s = ctx.current.createBufferSource(); s.buffer = bufs.current[k]; s.connect(ctx.current.destination); s.start(); };
  const stop = () => { clearInterval(timer.current); timer.current = null; setStep(-1); };
  const play = async () => {
    if (timer.current) return stop();
    await load();
    await ctx.current.resume();
    let i = 0;
    const tick = () => {
      if (i >= BAR.length * 4) return stop();
      BAR[i % 8].forEach(hit);
      setStep(i % 8);
      i += 1;
    };
    tick();
    timer.current = setInterval(tick, 333);
  };
  useEffect(() => () => clearInterval(timer.current), []);

  return (
    <div className="mt-4 flex flex-wrap items-center gap-3 rounded-2xl border border-border bg-card p-4" data-testid="drum-beat-player">
      <button onClick={play} data-testid="drum-beat-play"
        className="inline-flex items-center gap-2 rounded-full bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground hover:bg-primary/90">
        {step >= 0 ? <><Square size={14} /> Stop</> : <><Play size={14} /> Play the beat</>}
      </button>
      <div className="flex gap-1.5" data-testid="drum-beat-counts">
        {COUNT.map((c, i) => (
          <span key={i} className={`flex h-8 w-8 items-center justify-center rounded-lg font-mono text-sm transition-colors ${step === i ? "bg-primary text-primary-foreground" : "bg-secondary text-muted-foreground"}`}>{c}</span>
        ))}
      </div>
      <p className="w-full text-xs text-muted-foreground">Plays 4 bars at 90 bpm. Hi-hat = X on top, snare = middle, bass drum = bottom space.</p>
    </div>
  );
};
